var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"d-flex"},[_vm._l((_vm.links),function(ref,i){
var name = ref.name;
var path = ref.path;
return [_vm._t("item",[(i === _vm.links.length - 1)?_c('div',{key:path,staticClass:"link"},[_vm._v(_vm._s(name))]):_c('router-link',{key:path,staticClass:"link",attrs:{"to":path}},[_vm._v(_vm._s(name))])],{"text":name,"path":path,"index":i})]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }